module.exports = __webpack_public_path__ + "static/img/1_v2.5e4a504b.png";